import React, { useCallback } from 'react';
import { Route } from 'react-router-dom';
import { useAuth0 } from 'utils/auth0';
import AcceptTermsContainer from 'components/AcceptTerms/accept-terms-container';
import URLS from 'constants/URLS.gen.json';
import { TrustModal } from 'components/Trolley/Trust/trust-modal';
import useCurrentUser from '../../data-client/use-current-user';
import { useKycWidgetLink } from 'data-client/use-kyc-widget-link';

const PrivateRoute = ({ component: Component, render: Render, path, ...rest }) => {
  const { loading, isAuthenticated, loginWithRedirect } = useAuth0();
  const { data: { widgetLink } = {} } = useKycWidgetLink(true) || {};

  const [, , currentUserQuery, refetchUser] = useCurrentUser();
  const { data: dbUser, isFetching } = currentUserQuery;

  if (!loading && !isAuthenticated) loginWithRedirect({ appState: { targetUrl: path } });

  const render = useCallback(
    props =>
      isAuthenticated === false ? null : Render ? (
        <Render isPrivate={true} {...props} />
      ) : (
        <Component isPrivate={true} {...props} />
      ),
    // DEBT:
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [path]
  );

  const needsAccepting = dbUser
    ? Object.keys(URLS.TOS).filter(term => term !== 'privacy' && dbUser[term] !== URLS.TOS[term])
    : [];

  const isAcceptTermsModalVisible = dbUser && needsAccepting.length && !isFetching;
  // Only surface the KYC modal once all required agreements have been accepted.
  // The terms modal is mandatory (non-dismissible), so it must clear first.
  const isKYCModalVisible =
    dbUser && !needsAccepting.length && dbUser.kyc_verified_at === null && widgetLink && !isFetching;

  return (
    <>
      {isAcceptTermsModalVisible ? (
        <AcceptTermsContainer needsAccepting={needsAccepting} />
      ) : isKYCModalVisible ? (
        <TrustModal onlyForNewUsers onSuccess={refetchUser} />
      ) : null}
      <Route path={path} render={render} {...rest} />
    </>
  );
};

export default PrivateRoute;
